import { z } from "zod";

export interface EmailSchemaMessages {
  required: string;
  invalid: string;
}

const isEmail = (value: string) => z.email().safeParse(value).success;

// z.string({ error }) so a missing value reports the translated required message rather
// than zod's untranslated "expected string, received undefined".
export const emailSchema = ({ required, invalid }: EmailSchemaMessages) =>
  z
    .string({ error: required })
    .trim()
    .min(1, { message: required })
    .pipe(z.email({ message: invalid }));

export const optionalEmailSchema = ({ invalid }: Pick<EmailSchemaMessages, "invalid">) =>
  z
    .string()
    .trim()
    .optional()
    .refine(value => !value || isEmail(value), { message: invalid });
